<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      :title="'Édition du contact'"
      :subtitle="`${c ? c.last_name : ''} ${c ? c.first_name : ''}`">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <contact-form
          :source-loading="loading"
          :source-contact="c"
          :source-contact-notes="contactNotes"
          @submit="updateContact"
          @updateSources="updateSources"></contact-form>
      </div>
    </page-content>
  </div>
</template>

<script>
import ContactMixin from './ContactMixin'

export default {
  name: 'ContactEdit',
  components: {
    ContactForm: () => import('@/components/contacts/ContactForm')
  },
  mixins: [ContactMixin],
  watch: {
    '$route.params.id' (v) {
      this.initView(v)
    }
  }
}
</script>
